__turbopack_context__.v({
  "className": "OQ8u3G_className",
  "variable": "OQ8u3G_variable",
});
